module.exports = __webpack_public_path__ + "assets/d2d16304cee1a9f2b352b8722641ed01.mp4";